/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Player_Search_LabelInputs */



/**
* | output |
* | --- |
* | "Search by name" |
*
* @param {Add_Player_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const add_player_search_label = /** @type {((inputs?: Add_Player_Search_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Player_Search_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher par nom")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar por nombre")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar por nome")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca per nome")
	return /** @type {LocalizedString} */ ("Search by name")
});